export const removeDoubleAndStartingSpaces = (str: string): string =>
  str.replace(/\s\s+/g, ' ').replace(/^\s+|\s+$/g, '');
